import script from "./ProjectGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectGrid.vue?vue&type=script&setup=true&lang=js"

import "./ProjectGrid.vue?vue&type=style&index=0&id=53129471&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53129471"]])

export default __exports__